import React, { useState } from "react";
import {
  AppBar,
  Dialog,
  IconButton,
  Toolbar,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";

const CopyWorkoutModal = ({ open, onClose, onCopy, workout }) => {
  const [selectedDate, setSelectedDate] = useState(moment().add(1, "day"));

  const handleCopyWorkout = () => {
    if (selectedDate) {
      onCopy(selectedDate);
      setSelectedDate(moment().add(1, "day")); // Reset to tomorrow
    }
  };

  const handleClose = () => {
    setSelectedDate(moment().add(1, "day")); // Reset to tomorrow
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Copy Workout
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Select a date to copy "{workout?.name}" to:
        </Typography>
        <DatePicker
          value={selectedDate}
          label="Date"
          onChange={(newValue) => setSelectedDate(newValue)}
          slotProps={{
            textField: {
              size: "small",
              fullWidth: true,
              margin: "normal",
              error: false,
              helperText: "",
            },
            popper: {
              placement: "bottom-start",
              modifiers: [
                {
                  name: "preventOverflow",
                  enabled: true,
                },
              ],
            },
          }}
          disableFuture={false}
          disablePast={false}
          showDaysOutsideCurrentMonth={true}
          reduceAnimations={true}
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleCopyWorkout}
            variant="contained"
            color="primary"
            disabled={!selectedDate}
          >
            Copy Workout
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default CopyWorkoutModal;
